const loadDetailReviewsWidget = (sku, lang, settings = {}) => {
	// eslint-disable-next-line no-undef
	new ReviewsWidget("#ReviewsWidget", {
		store: "every-foods.com",
		widget: "polaris",

		options: {
			types: "product_review",
			lang,
			layout: "",
			per_page: settings.per_page || 5,
			store_review: {
				hide_if_no_results: true,
			},
			third_party_review: {
				hide_if_no_results: true,
			},
			product_review: {
				sku,
				hide_if_no_results: settings.product_review?.hide_if_no_results || true,
			},
			questions: {
				hide_if_no_results: settings.questions?.hide_if_no_results || false,
				enable_ask_question: settings.questions?.enable_ask_question || true,
				show_dates: settings.questions?.show_dates || false,
				grouping: sku
			},
			header: {
				enable_summary: settings.header?.enable_summary || true,
				enable_ratings: settings.header?.enable_ratings || true,
				enable_attributes: settings.header?.enable_attributes || true,
				enable_image_gallery: settings.header?.enable_image_gallery || true,
				enable_percent_recommended: settings.header?.enable_percent_recommended || false,
				enable_write_review: settings.header?.enable_write_review || true,
				enable_ask_question: settings.header?.enable_ask_question || false,
				enable_sub_header: settings.header?.enable_sub_header || true,
				rating_decimal_places: 1,
				use_write_review_button: false,
			},

			filtering: {
				enable: true,
				enable_text_search: true,
				enable_sorting: true,
				enable_product_filter: false,
				enable_media_filter: true,
				enable_overall_rating_filter: true,
				enable_language_filter: false,
				enable_language_filter_language_change: false,
				enable_ratings_filters: true,
				enable_attributes_filters: true,
				enable_expanded_filters: false,
			},
			reviews: {
				enable_avatar: false,
				enable_reviewer_name: true,
				enable_reviewer_address: true,
				reviewer_address_format: "city, country",
				enable_verified_badge: true,
				enable_subscriber_badge: true,
				// review_content_filter: "no_comments",
				enable_reviewer_recommends: false,
				enable_attributes: true,
				enable_product_name: true,
				enable_review_title: undefined,
				enable_replies: true,
				enable_images: true,
				enable_ratings: true,
				enable_share: false,
				enable_helpful_vote: false,
				enable_helpful_display: false,
				enable_report: false,
				enable_date: true,
				enable_third_party_source: true,
				enable_duplicate_reviews: undefined,

			},
		},
		translations: {
			"Verified Customer": "Verified Customer"
		},
		styles: {
			"--base-font-size": "16px",

			//Button styles (shared between buttons):
			"--common-button-font-family": "inherit",
			"--common-button-font-size": "16px",
			"--common-button-font-weight": "500",
			"--common-button-letter-spacing": "0",
			"--common-button-text-transform": "none",
			"--common-button-vertical-padding": "10px",
			"--common-button-horizontal-padding": "20px",
			"--common-button-border-width": "2px",
			"--common-button-border-radius": "0px",

			//Primary button styles:
			"--primary-button-bg-color": "#0E1311",
			"--primary-button-border-color": "#0E1311",
			"--primary-button-text-color": "#ffffff",

			//Secondary button styles:
			"--secondary-button-bg-color": "transparent",
			"--secondary-button-border-color": "#0E1311",
			"--secondary-button-text-color": "#0E1311",

			//Star styles:
			"--common-star-color": "#FBCE0B",
			"--common-star-disabled-color": "rgba(0,0,0,0.25)",
			"--medium-star-size": "22px",
			"--small-star-size": "19px",

			//Heading styles:
			"--heading-text-color": "#0E1311",
			"--heading-text-font-weight": "600",
			"--heading-text-font-family": "inherit",
			"--heading-text-line-height": "1.4",
			"--heading-text-letter-spacing": "0",
			"--heading-text-transform": "none",

			//Body text styles:
			"--body-text-color": "#0E1311",
			"--body-text-font-weight": "400",
			"--body-text-font-family": "inherit",
			"--body-text-line-height": "1.4",
			"--body-text-letter-spacing": "0",
			"--body-text-transform": "none",

			//Input field styles:
			"--inputfield-text-font-family": "inherit",
			"--input-text-font-size": "14px",
			"--inputfield-text-font-weight": "400",
			"--inputfield-text-color": "#0E1311",
			"--inputfield-border-color": "rgba(0,0,0,0.2)",
			"--inputfield-background-color": "transparent",
			"--inputfield-border-width": "1px",
			"--inputfield-border-radius": "0px",

			"--common-border-color": "rgba(0,0,0,0.15)",
			"--common-border-width": "1px",
			"--common-sidebar-width": "190px",

			//Filters panel styles:
			"--filters-panel-bg-color": "transparent",
			"--filters-panel-font-size": "16px",
			"--filters-panel-text-color": "16px",
			"--filters-panel-horizontal-padding": "0",
			"--filters-panel-vertical-padding": "0",

			//Slider indicator (for attributes) styles:
			"--slider-indicator-bg-color": "rgba(0,0,0,0.1)",
			"--slider-indicator-button-color": "#0E1311",
			"--slider-indicator-width": "190px",

			//Badge styles:
			"--badge-icon-color": "#0E1311",
			"--badge-icon-font-size": "inherit",
			"--badge-text-color": "#0E1311",
			"--badge-text-font-size": "inherit",
			"--badge-text-letter-spacing": "inherit",
			"--badge-text-transform": "inherit",

			//Author styles:
			"--author-font-size": "inherit",
			"--author-text-transform": "none",

			//Author avatar styles:
			"--avatar-thumbnail-size": "60px",
			"--avatar-thumbnail-border-radius": "100px",
			"--avatar-thumbnail-text-color": "#0E1311",
			"--avatar-thumbnail-bg-color": "rgba(0,0,0,0.1)",

			//Product photo or review photo styles:
			"--photo-video-thumbnail-size": "80px",
			"--photo-video-thumbnail-border-radius": "0px",

			//Media (photo & video) slider styles:
			"--mediaslider-scroll-button-icon-color": "#0E1311",
			"--mediaslider-scroll-button-bg-color": "rgba(255, 255, 255, 0.85)",
			"--mediaslider-overlay-text-color": "#ffffff",
			"--mediaslider-overlay-bg-color": "rgba(0, 0, 0, 0.8))",
			"--mediaslider-item-size": "110px",

			//Pagination & tabs styles (normal):
			"--pagination-tab-text-color": "#0E1311",
			"--pagination-tab-text-transform": "none",
			"--pagination-tab-text-letter-spacing": "0",
			"--pagination-tab-text-font-size": "16px",
			"--pagination-tab-text-font-weight": "600",

			//Pagination & tabs styles (active):
			"--pagination-tab-active-text-color": "#0E1311",
			"--pagination-tab-active-text-font-weight": "600",
			"--pagination-tab-active-border-color": "#0E1311",
			"--pagination-tab-border-width": "3px",
		},
	});
};

export default loadDetailReviewsWidget;